const styleSheet = () => ({
  checkedColumn: {
    marginLeft: '9px',
    marginBottom: '9px',
    height: '20px',
    zIndex: 99999999,
    '&:hover': {
      cursor: 'default',
    },
  },
  checkedReposition: {
    height: '3px',
    width: '16px',
    border: '1px solid #6373A4',
    borderLeft: 'none',
    borderRight: 'none',
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: '12px',
    cursor: 'move',
  },
  checkedColumnName: {
    height: '16px',
    width: 'auto',
    color: '#085FE5',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: '10px',
    userSelect: 'none',
  },
});

export default styleSheet;
